export default "__VITE_ASSET__DZZKNRlz__"